'use strict';

var util = require('../util/property-util');

module.exports = /*@ngInject*/ [function () {
    var factory = {};

    factory.logError = function (response, userId) {
    };

    return factory;
}];
